import { ItemView, WorkspaceLeaf } from "obsidian";

export const VIEW_TYPE_MONACO = "monaco-editor-view";

export class MonacoEditorView extends ItemView {
  private editor: any;

  constructor(leaf: WorkspaceLeaf) {
    super(leaf);
  }

  getViewType() {
    return VIEW_TYPE_MONACO;
  }

  getDisplayText() {
    return "Monaco Editor";
  }

  async onOpen() {
    console.log("Monaco view opened ✅");
    this.containerEl.empty();
    this.containerEl.createEl("h2", { text: "Monaco Editor Loading..." });

    const editorDiv = this.containerEl.createDiv("monaco-editor-container");

    // Load Monaco from CDN
    if (!(window as any).monaco) {
      await new Promise<void>((resolve) => {
        const loader = document.createElement("script");
        loader.src =
          "https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.44.0/min/vs/loader.min.js";
        loader.onload = () => {
          (window as any).require.config({
            paths: {
              vs: "https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.44.0/min/vs",
            },
          });
          (window as any).require(["vs/editor/editor.main"], () => {
            console.log("Monaco loaded ✅");
            resolve();
          });
        };
        document.body.appendChild(loader);
      });
    }

    this.editor = (window as any).monaco.editor.create(editorDiv, {
      value: "// Monaco editor inside Obsidian\nconsole.log('Hello!');",
      language: "javascript",
      theme: "vs-dark",
      automaticLayout: true,
    });
  }

  async onClose() {
    if (this.editor) {
      this.editor.dispose();
      this.editor = null;
    }
  }
}